import { render, staticRenderFns } from "./CalendarTermDialogForEdit.vue?vue&type=template&id=f8489a54&scoped=true&"
import script from "./CalendarTermDialogForEdit.vue?vue&type=script&lang=js&"
export * from "./CalendarTermDialogForEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8489a54",
  null
  
)

export default component.exports